module.exports = __webpack_public_path__ + "static/img/mail-game-3.8042be7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mail-game-3.png
// module id = Lta3
// module chunks = 1